import { render, staticRenderFns } from "./tesk.vue?vue&type=template&id=0f426620&scoped=true"
import script from "./tesk.vue?vue&type=script&lang=js"
export * from "./tesk.vue?vue&type=script&lang=js"
import style0 from "./tesk.vue?vue&type=style&index=0&id=0f426620&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f426620",
  null
  
)

export default component.exports